/**
 * Layout configuration
 * Layout-related constants (sidebar width, header height, etc.)
 */

export const layout = {
  sidebar: {
    width: 280, // Sidebar width in pixels
  },
  header: {
    height: 64, // Header height in pixels
  },
  content: {
    maxWidth: 1200, // Max content width in pixels
  },
};

